import { useRootSelector } from '../../store/hooks';
import { selectTenantConfig } from '../../store/features/tenantConfig';
import { TenantDomainId } from '../../store/features/pageConfig';
import {
  isKnect365Tenant,
  KNECT365_TERMS_AND_CONDITIONS_LINK,
} from '../../helpers/knect365TenantHelpers';

export function useGetTermsAndConditionsUrl() {
  const { id: tenantId } = useRootSelector(selectTenantConfig);
  const knect365Tenant = isKnect365Tenant(tenantId);
  if (knect365Tenant || tenantId === TenantDomainId.CONNECTECHASIA)
    return KNECT365_TERMS_AND_CONDITIONS_LINK;

  return '/terms-and-conditions/';
}
